<template>
<!-- Queue icon and its open count, drawn inside a queue link in the queue panel (taskPanel.vue) -->
    <span class="contents">
        <slot name="icon" />
        <span v-if="total > 0" class="bn-count text-amber">{{ total }}</span>
    </span>
</template>

<script>
export default {
    props:{
        total:{type:Number,default:0},
    },
    setup () {
        return {}
    }

}
</script>

<style>

</style>